export const HomeRoute = "/";
export const ProductsRoute = "/products";
export const ViewProductRoute = "/products/view";
export const EditProductRoute = "/products/edit";
export const PurchaseOrdersRoute = "/purchase-orders";
export const EditPurchaseOrderRoute = "/purchase-orders/edit";
export const AdjustStockRoute = "/products/adjust-stock";
export const ViewPurchaseOrderRoute = "/purchase-orders/view";
export const QuotesRoute = "/quotes";
export const EditQuoteRoute = "/quotes/edit";
export const ViewQuoteRoute = "/quotes/view";
export const BillsRoute = "/bills";
export const SuppliersRoute = "/suppliers";
export const CustomSalesRoute = "/custom-sales";

export const LocationsRoute = "/locations";
export const StocktakeRoute = "/stocktake";
export const StockValueRoute = "/stock-value";
export const AuditLogRoute = "/audit-logs";
